import messages from './readinessMessages';
// Same counts as the readiness report: time table warnings don't count as attention points.
export const getSectionStats = (readiness) => [
    {
        view: 'timeTables',
        step: 1,
        title: messages.TimeTablesTitle,
        intro: messages.TimeTablesIntro,
        total: readiness.employees.length,
        issues: readiness.employees.filter(e => e.issues.length > 0).length,
    },
    {
        view: 'templates',
        step: 2,
        title: messages.TemplatesTitle,
        intro: messages.TemplatesIntro,
        total: readiness.templates.length,
        issues: readiness.templates.filter(t => !t.isMainTaskAssigned && !t.allActualSubtasksAssigned)
            .length,
    },
    {
        view: 'schedule',
        step: 3,
        title: messages.ScheduleTitle,
        intro: messages.ScheduleIntro,
        total: readiness.scheduleCheckedCount,
        issues: readiness.scheduleIssues.length,
    },
    {
        view: 'users',
        step: 4,
        title: messages.UsersTitle,
        intro: messages.UsersIntro,
        total: readiness.relationCheckedCount,
        issues: readiness.relationIssues.length,
    },
];
// Floored, so an imperfect score never rounds up to a misleading 100%.
export const readyPercentage = ({ total, issues }) => issues === 0 ? 100 : Math.floor(((total - issues) * 100) / total);
